module.exports = __webpack_public_path__ + "img/folder_color.2793942c.svg";